import { connect } from 'react-redux';
import { remoteModeratorActions } from '@lifesize/nucleus';
import { closeInCallModal } from 'actions/InCallModal';
import ConfirmEndRemoteModerationModal from 'components/ConfirmEndRemoteModerationModal';

const mapDispatchToProps = dispatch => ({
  onCancelClicked: () => dispatch(closeInCallModal()),
  onConfirmClicked: () => {
    dispatch(closeInCallModal());
    dispatch(remoteModeratorActions.leaveCurrent());
  }
});

export default connect(null, mapDispatchToProps)(ConfirmEndRemoteModerationModal);
